import React from "react";
import { mediaUrl } from "../lib/api";
import { useRealtime } from "../context/RealtimeContext";

const sizes = { sm: 34, md: 44, lg: 64, xl: 120 };

// Measured transparent-window geometry per frame (as fraction of the 1:1 PNG).
// d = larger window dimension so the round photo fully fills the window (ring overlaps the photo edge, no gap).
const FRAME_GEOM = {
  spotter_plus: { d: 0.672, cx: 0.499, cy: 0.5155 },
  gold: { d: 0.672, cx: 0.5115, cy: 0.511 },
  den: { d: 0.58, cx: 0.499, cy: 0.508 },
};

export function Avatar({ user, size = "md", showPresence = false, className = "", frame = true }) {
  const px = sizes[size] || size;
  const rt = useRealtime();
  const online = showPresence && rt && (rt.isOnline(user?.id) || user?.online);
  const initials = (user?.name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  const frameUrl = frame && user?.profile_frame_url;
  const g = FRAME_GEOM[user?.profile_frame] || { d: 0.64, cx: 0.5, cy: 0.5 };
  const fw = px / g.d;
  const fleft = px * (0.5 - g.cx / g.d);
  const ftop = px * (0.5 - g.cy / g.d);
  const ringClass = frameUrl ? "" : "border-2 border-black";
  return (
    <div className={`relative inline-block ${className}`} style={{ width: px, height: px }}>
      {user?.avatar_url ? (
        <img src={mediaUrl(user.avatar_url)} alt={user.name}
          className={`rounded-full object-cover w-full h-full ${ringClass}`} />
      ) : (
        <div className={`rounded-full w-full h-full flex items-center justify-center font-heading font-bold text-spotter-cream ${ringClass}`}
          style={{ background: "#520202", fontSize: px * 0.36 }}>{initials}</div>
      )}
      {frameUrl && (
        <img src={frameUrl} alt="" aria-hidden="true" data-testid="avatar-frame"
          className="absolute pointer-events-none select-none"
          style={{ width: fw, height: fw, left: fleft, top: ftop, maxWidth: "none", zIndex: 5 }} />
      )}
      {online && (
        <span className="spot-dot absolute" style={{ right: 0, bottom: 0, zIndex: 10 }} data-testid="presence-dot" />
      )}
    </div>
  );
}
